'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasChildren = function hasChildren() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      index = _ref.index,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  return function (rows) {
    if (index < 0) {
      return false;
    }

    // See if the next item points to the current one.
    // This relies on rows order!
    var currentItem = rows[index];
    var nextItem = rows[index + 1];

    return !!(nextItem && currentItem[idField] === nextItem[parentField]);
  };
};

exports.default = hasChildren;